import React from 'react'
import { inject, observer } from 'mobx-react'
import {
  ProductMetaDataItem,
  CreateProduct,
  CreateChildProduct,
  lowerCasedReservedKeys,
} from '../ProductStore'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { Button, Input, Icon } from 'antd'

const { TextArea } = Input

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  product: CreateProduct | CreateChildProduct
  blockSaving: (blockSaving: boolean, errorMessage?: string) => void
}

interface State {
  duplicateKeys: string[]
  metaData: ProductMetaDataItem[]
}

@inject('currentCompanyStore')
@observer
export class CustomFieldsTab extends React.Component<Props, State> {
  company = this.props.currentCompanyStore!.company!

  constructor(props: Props) {
    super(props)
    this.state = {
      duplicateKeys: [],
      metaData: this.nonReservedMetaData,
    }
  }

  removeMetaDataItem = (index: number, metaDataItem: ProductMetaDataItem) => {
    const { metaData } = this.state
    metaData.splice(index, 1)
    this.setState({ metaData })
    this.props.product.metaData.removeMetaDataItem(metaDataItem)
  }

  checkForDuplicateKeys = (
    event: React.ChangeEvent<HTMLInputElement>,
    metaData: ProductMetaDataItem,
  ) => {
    const { product } = this.props
    metaData.setKey(event.target.value)

    const metaDataKeys = product.metaData.metaData.map((metaDataItem) =>
      metaDataItem.metaKey.toLowerCase(),
    )

    const duplicateKeys = metaDataKeys
      .map((name) => {
        return {
          count: 1,
          name: name,
        }
      })
      .reduce((a, b) => {
        a[b.name] = (a[b.name] || 0) + b.count
        return a
      }, {})

    delete duplicateKeys['']

    for (const key in duplicateKeys) {
      if (duplicateKeys[key] > 1) {
        this.props.blockSaving(true, 'Duplicate key for custom fields, please use another key name')
        return
      }
    }
    this.props.blockSaving(false)
  }

  get nonReservedMetaData() {
    const { product } = this.props

    const nonReservedMetaData = product.metaData.metaData.filter((metaDataItem) => {
      return !lowerCasedReservedKeys.includes(metaDataItem.metaKey.toLowerCase())
    })

    return nonReservedMetaData
  }

  render() {
    const { product } = this.props
    const isDeleted =
      product instanceof CreateProduct ? product.isDeleted : product.parentProduct.isDeleted

    return (
      <>
        <div className='form-group row card__body__text'>
          <div className='col-xl-3'>
            <label>Custom fields</label>
            <div className='text-muted'>This is for advanced users only</div>
          </div>
          <div className='col-xl-9'>
            {this.state.metaData.map((metaData, index) => (
              <div className='row mb-2' key={`${index}${product.metaData.metaData.length}`}>
                <div className='col-md-3 pr-md-0'>
                  <Input
                    className='mb-2'
                    placeholder={'Key'}
                    defaultValue={metaData.metaKey}
                    onChange={(event) => {
                      this.checkForDuplicateKeys(event, metaData)
                      product.changed = true
                    }}
                  />
                </div>
                <div className='col-md-7'>
                  <TextArea
                    className='mb-1'
                    rows={1}
                    placeholder={'Value'}
                    defaultValue={metaData.metaValue || undefined}
                    onChange={(event) => {
                      metaData.setValue(event.target.value)
                      product.changed = true
                    }}
                  />
                </div>
                <div
                  className='col-md-2'
                  onClick={() => {
                    this.removeMetaDataItem(index, metaData)
                    product.changed = true
                  }}
                >
                  <div className='form-group'>
                    <Icon type='delete' theme='filled' />
                  </div>
                </div>
              </div>
            ))}
            <Button
              icon='plus'
              disabled={isDeleted}
              onClick={() => {
                const newMetaDataItem = new ProductMetaDataItem()
                product.metaData.addMetaDataItem(newMetaDataItem)
                this.setState({ metaData: [...this.state.metaData, newMetaDataItem] })
                product.changed = true
              }}
            >
              Add custom field
            </Button>
          </div>
        </div>
      </>
    )
  }
}
